const splitTopicUrlnameAndFilterId = (urlname) => {
  const urlnameArr = urlname?.split("-");

  if (!urlnameArr) {
    return {
      urlname: "",
      filter_id: "",
    };
  }

  if (/^[0-9]+$/.test(urlnameArr[urlnameArr.length - 1])) {
    const filter_id = urlnameArr.pop();
    return {
      urlname: urlnameArr.join("-"),
      filter_id,
    };
  } else {
    return {
      urlname: urlnameArr.join("-"),
      filter_id: "",
    };
  }
};

export default splitTopicUrlnameAndFilterId;
